export default __webpack_public_path__ + "39052f23f86ad00bbdcf0a6205b4df06.png";